// Casa as mensagens otimistas (as que aparecem na hora, com o reloginho) com as
// reais que o servidor devolveu.
//
// O casamento é pelo TEXTO, porque a otimista nasce antes de a mensagem ter id.
// E precisa ser UM-PRA-UM: antes, uma mensagem real confirmava QUALQUER
// pendente com o mesmo texto. Com a fila de envio isso vira bug visível — o
// atendente manda "ok" e "ok", a primeira volta do servidor, e as DUAS somem da
// tela; a segunda reaparece só quando sai de verdade.
//
// `somentePorId`: pendente que não dá pra casar por texto (foto, áudio —
// aparecem como "Enviando foto…"). Quem tira essas é a própria fila, pelo id,
// depois que o servidor confirma.

export function reconciliarPendentes(mensagens, pendentes, { toleranciaMs = 60000 } = {}) {
  const usadas = new Set();
  const aindaPendentes = [];
  (pendentes || []).forEach((p) => {
    if (p.somentePorId) { aindaPendentes.push(p); return; }
    const inicio = new Date(p.criada_em).getTime() - toleranciaMs;
    // Tolerância de 60s: cobre relógio do tablet e do servidor discordando, sem
    // casar com uma mensagem idêntica antiga (essa seria bem mais velha).
    const i = (mensagens || []).findIndex((m, idx) => !usadas.has(idx)
      && m.direcao === 'out'
      && (m.conteudo || '') === (p.conteudo || '')
      && new Date(m.criada_em).getTime() >= inicio);
    if (i >= 0) usadas.add(i);
    else aindaPendentes.push(p);
  });
  return aindaPendentes;
}
